import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import ContentTariffsSelected from "@/icons/Content/Tariffs/Selected";

import { EqualHeightElement } from "../../EqualHeight/EqualHeightElement";
import { Icon } from "../../Icon";

import styles from "./Bonus.scss";

const Bonus = forwardRef(
  ({ children, iconWrapperProps, ...restProps }, ref) => (
    <div ref={ref} className={styles.bonus} {...restProps}>
      <EqualHeightElement name="Bonus">
        <div className={styles.bonusInner} {...restProps}>
          <span className={styles.iconWrapper}>
            <Icon
              icon={ContentTariffsSelected}
              size={Icon.Size.parent}
              wrapperProps={{
                ...iconWrapperProps,
              }}
            />
          </span>
          <span className={styles.textContent}>{children}</span>
        </div>
      </EqualHeightElement>
    </div>
  )
);

Bonus.displayName = "TariffTile.Bonus";

Bonus.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,

  iconWrapperProps: PropTypes.objectOf(PropTypes.any),
};

Bonus.defaultProps = {
  iconWrapperProps: null,
};

export default Bonus;
